import * as React from 'react';

import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { useShouldShowShadeListButton } from './ProductBaseInfo/Variants/VariantsColorPickers/useShouldShowShadeListButton';
import { getVariantName } from './utils';

type Product = NonNullable<
  GetCatalogProductViewQuery['productDetailByCatalogMasterId']
>;

interface IVariantNameProps {
  variant: Product['variants'][number];
}

export const VariantName: React.FC<IVariantNameProps> = ({ variant }) => {
  const { shouldShowShadeListButton } = useShouldShowShadeListButton();

  if (shouldShowShadeListButton) {
    const { amount, unit } = variant.parameters ?? { amount: '', unit: '' };
    return <span>{`${amount ?? ''} ${unit ?? ''}`.trim()}</span>;
  }

  const name = getVariantName(variant);
  return name ? <span>{name}</span> : null;
};
